export class Constants {
  public static readonly maxLevel = 5;
  public static readonly paymentSuccessDurationInSeconds = 5;
  public static readonly questionDurationInSeconds = 20;
  public static readonly showCorrectAnswerDurationInMilliseconds = 2000;
}
